
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent2 as ObiWindApparent2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-2.js';
 
 
 

 
 export const ObiWindApparent2 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-2',
   elementClass: ObiWindApparent2Element,
   events: {
     
   }
  });
 
 